<adapt-display-accordion-hierarchy [hierarchy]="ownersHierarchy$ | async"></adapt-display-accordion-hierarchy>
